import { defineStore } from 'pinia'

export default defineStore('modalAddContent', {
  state: () => ({
    show: false,
    preselectedCategorieId: null
  }),
  actions: {
    resetPreselectedCategorie() {
      this.preselectedCategorieId = null
    }
  }
})
